import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { INotificationRequest } from '../models/notification';
import { NotificationPagedResult, UserNotificationResult } from '../models/notification-result';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    Accept: 'application/json',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private http: HttpClient) {}

  getNotification(payload: INotificationRequest): Observable<NotificationPagedResult> {
    let url = `${environment.apiBase}/Notifications/filter`;
    url += `?pageNumber=${payload.pageNumber}&pageSize=${payload.pageSize}`;
    if (payload.state) {
      url += `&state=${payload.state}`;
    }
    if (payload.type) {
      url += `&type=${payload.type}`;
    }

    return this.http.get<NotificationPagedResult>(url, httpOptions);
  }
  markRead(id: string): Observable<UserNotificationResult> {
    const url = `${environment.apiBase}/userNotification/${id}/actions/markAsRead`;
    return this.http.patch<UserNotificationResult>(url, { id }, httpOptions);
  }

  markAllAsRead(): Observable<number> {
    const url = `${environment.apiBase}/userNotification/actions/markAllAsRead`;
    return this.http.patch<number>(url, {}, httpOptions);
  }
}
